/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Stem
 */
export interface Stem {
    /**
     * 
     * @type {string}
     * @memberof Stem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Stem
     */
    parentId: string;
    /**
     * 
     * @type {string}
     * @memberof Stem
     */
    category: string;
    /**
     * 
     * @type {string}
     * @memberof Stem
     */
    cid: string;
    /**
     * 
     * @type {string}
     * @memberof Stem
     */
    userId: string;
    /**
     * 
     * @type {number}
     * @memberof Stem
     */
    blocknumber: number;
    /**
     * 
     * @type {string}
     * @memberof Stem
     */
    origFilename: string;
}

/**
 * Check if a given object implements the Stem interface.
 */
export function instanceOfStem(value: object): value is Stem {
    let isInstance = true;
    isInstance = isInstance && "id" in value && value["id"] !== undefined;
    isInstance = isInstance && "parentId" in value && value["parentId"] !== undefined;
    isInstance = isInstance && "category" in value && value["category"] !== undefined;
    isInstance = isInstance && "cid" in value && value["cid"] !== undefined;
    isInstance = isInstance && "userId" in value && value["userId"] !== undefined;
    isInstance = isInstance && "blocknumber" in value && value["blocknumber"] !== undefined;
    isInstance = isInstance && "origFilename" in value && value["origFilename"] !== undefined;

    return isInstance;
}

export function StemFromJSON(json: any): Stem {
    return StemFromJSONTyped(json, false);
}

export function StemFromJSONTyped(json: any, ignoreDiscriminator: boolean): Stem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'parentId': json['parent_id'],
        'category': json['category'],
        'cid': json['cid'],
        'userId': json['user_id'],
        'blocknumber': json['blocknumber'],
        'origFilename': json['orig_filename'],
    };
}

export function StemToJSON(value?: Stem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'parent_id': value.parentId,
        'category': value.category,
        'cid': value.cid,
        'user_id': value.userId,
        'blocknumber': value.blocknumber,
        'orig_filename': value.origFilename,
    };
}

